import React from "react";
import { Style } from "@glamcorner/gc-types/generated/types";
import { StyleItem } from "../StyleItem";
import { CollectionDesignation } from "../../interfaces";
import "./styleItems.scss";

export interface StyleItemsProps {
  styles: Style[];
  tag?: (styleItem: Style, collectionDesignation: CollectionDesignation) => string | undefined;
  camelCaseMicroData?: boolean;
  withStyleImageCarousels: boolean;
  hashUrl: string;
  collectionDesignation: CollectionDesignation;
}

export const StyleItems: React.FC<StyleItemsProps> = ({
  styles,
  tag,
  camelCaseMicroData,
  withStyleImageCarousels,
  hashUrl,
  collectionDesignation,
}) => {
  return (
    <div id="product-list" data-app="catalogue">
      {styles.map((styleModel: Style, index) => {
        return (
          <StyleItem
            hashUrl={hashUrl}
            key={index}
            position={index + 1}
            styleItem={styleModel}
            tag={tag}
            camelCaseMicroData={camelCaseMicroData}
            withStyleImageCarousels={withStyleImageCarousels}
            collectionDesignation={collectionDesignation}
          />
        );
      })}
      <script dangerouslySetInnerHTML={{ __html: "GlamCornerCore.bus.broadcast('product-list-loaded', {});" }} />
    </div>
  );
};
